import 'common/polyfill.js';

import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'mobx-react';
import 'normalize.css';
import './index.module.scss';

import { unregister } from './registerServiceWorker';
import LocalizedApp from './LocalizedApp';
import ContentStore from 'stores/Content.store';
import ConsentsStore from './stores/Consents.store';

ReactDOM.render(
  <Provider ConsentsStore={ConsentsStore}>
    <Provider ContentStore={ContentStore}>
      <Router>
        <Route path="/:lang([a-zA-Z]{2})?" component={LocalizedApp} />
      </Router>
    </Provider>
  </Provider>,
  document.getElementById('app-root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js